import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Button } from "semantic-ui-react";

import SimplePreloader from "../../components/preloaders/SimplePreloader.jsx";
import SegmentMessage from "../../components/forms/messages/SegmentMessage.jsx";
import SentryHeader from "../../components/sentry/SentryHeader.jsx";
import RedirectWithReset from "../../components/utils/RedirectWithReset.jsx";

import { verifyUser } from "../../state/reducers/signup/signUpActions.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class VerifyUser extends Component {
  static propTypes = {
    verified: PropTypes.bool.isRequired,
    isErrored: PropTypes.bool.isRequired,
    verifyUser: PropTypes.func.isRequired
  };

  state = {
    skipToSentry: false,
    tokenNotFound: false
  };

  componentDidMount() {
    const { token } = this.props.match.params;

    if (token) {
      this.props.verifyUser(token);
    } else {
      this.setState({ tokenNotFound: true });
    }
  }

  onContinueClick = () => {
    this.setState({ skipToSentry: true });
  };

  // -- RENDER -- //

  getMessageData = () => {
    const { verified } = this.props;

    return {
      copyKey: verified ? "success_message" : "error_message",
      negative: !verified,
      positive: verified
    };
  };

  render() {
    const { verified, isErrored, copy } = this.props;
    const { skipToSentry, tokenNotFound } = this.state;

    if (skipToSentry === true) {
      return <RedirectWithReset push to="/" />;
    }

    if (isErrored === true || tokenNotFound === true || verified === true) {
      const message = this.getMessageData();

      return (
        <div className="sentry">
          <SentryHeader />
          <div className="sentry-form">
            <Segment textAlign="left">
              <SegmentMessage
                title={copy(`sentry.verify.${message.copyKey}.title`)}
                negative={message.negative}
                positive={message.positive}
              />
              <p>{copy(`sentry.verify.${message.copyKey}.description`)}</p>
              <Button onClick={this.onContinueClick} primary fluid>
                {copy(`sentry.verify.${message.copyKey}.continue_cta`)}
              </Button>
            </Segment>
          </div>
        </div>
      );
    }

    return <SimplePreloader />;
  }
}

const mapStateToProps = state => ({
  verified: state.verify.isSuccess,
  isErrored: state.verify.isErrored,
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  verifyUser: token => dispatch(verifyUser(token))
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyUser);
